import { AssignSGLRequest } from '@/api/Trading-Accounts/Types/AssignSGLDto'
import { AuditLog } from 'api/Clients/Types/AuditLog'
import { LeadDto } from 'api/Clients/Types/LeadDto'
import { NameDto } from 'api/Common/Types'
import { CreatedLeadResponseDto } from 'api/Leads/Types/CreatedLeadResponseDto'
import { CreateLeadDto } from 'api/Leads/Types/CreateLeadDto'
import { CreateLeadNote } from 'api/Leads/Types/CreateLeadNote'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'
import { LeadNoteDto } from 'api/Leads/Types/LeadNoteDto'
import { UpdateLead } from 'api/Leads/Types/UpdateLead'
import { UpdateLeadNote } from 'api/Leads/Types/UpdateLeadNote'
import { VerifiableActionDto } from 'api/Leads/Types/VerifiableActionDto'
import { PageData } from 'api/Pagination/Types'
import { WelcomeTradingAccount } from 'api/Trading-Accounts/Types/WelcomeTradingAccount'
import { WelcomeTradingAccountDto } from 'api/Trading-Accounts/Types/WelcomeTradingAccountDto'

import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'

export class LeadsApiClient {
  constructor(private apiClient: ApiClient) {}

  getLeads: (query?: PageQuery) => Promise<PageData<LeadDto[]>> = (query) => {
    query = query || {}
    return this.apiClient.get(`leads/leads?${preparePageQueryParams(query)}`)
  }
  getDetailedLead: (id: string) => Promise<LeadDetailsDto> = (id) => {
    return this.apiClient.get(`leads/leads/${id}`)
  }
  updateLead: (id: string, data: UpdateLead) => Promise<LeadDetailsDto> = (id, data) => {
    return this.apiClient.put(`leads/leads/${id}`, data)
  }
  sendLeadEmailVerificationRequest: (id: string) => Promise<void> = (id) => {
    return this.apiClient.put(`leads/leads/${id}/resend-email`, {})
  }
  getLeadSalesStatus: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`leads/leads/sales-statuses`)
  }
  getLeadSources: (query?: PageQuery) => Promise<NameDto[]> = (query) => {
    return this.apiClient.get(`leads/leads/lead-sources?${new URLSearchParams(query)}`)
  }
  getLeadDemoAccounts: (
    id: string,
    pageSize?: number
  ) => Promise<PageData<WelcomeTradingAccount[]>> = (id, pageSize = 100) => {
    return this.apiClient.get(
      `trading-accounts/leads/demo-accounts?Search=LeadId == ${id}&pageSize=${pageSize}`
    )
  }
  getLeadWelcomeAccounts: (
    id: string,
    pageSize?: number
  ) => Promise<PageData<WelcomeTradingAccount[]>> = (id, pageSize = 100) => {
    return this.apiClient.get(
      `trading-accounts/leads/welcome-accounts?Search=LeadId == ${id}&pageSize=${pageSize}`
    )
  }
  getLeadsWelcomeAccounts: (query?: PageQuery) => Promise<PageData<WelcomeTradingAccountDto[]>> = (
    query
  ) => {
    return this.apiClient.get(
      `trading-accounts/leads/welcome-accounts?${preparePageQueryParams(query)}`
    )
  }
  getLeadsDemoAccounts: (query?: PageQuery) => Promise<PageData<WelcomeTradingAccountDto[]>> = (
    query
  ) => {
    return this.apiClient.get(
      `trading-accounts/leads/demo-accounts?${preparePageQueryParams(query)}`
    )
  }
  getLeadEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`leads/leads/${id}/events`)
  }
  getLeadVerifiableActions: (id: string) => Promise<VerifiableActionDto[]> = (id) => {
    return this.apiClient.get(`leads/leads/${id}/verifiable-actions`)
  }
  addLead: (formData: CreateLeadDto) => Promise<CreatedLeadResponseDto> = (formData) => {
    return this.apiClient.post(`leads/leads`, formData)
  }
  createLeadFromClient: (clientId: string) => Promise<{ leadId: string }> = (clientId) => {
    return this.apiClient.post(`leads/leads/create-for-client`, { clientId })
  }
  uploadLeads: (formData: FormData) => Promise<LeadDto[]> = (formData) => {
    return this.apiClient.upload('POST', `leads/leads/upload`, formData)
  }
  uploadLeadsPreview: (formData: FormData) => Promise<LeadDto[]> = (formData) => {
    return this.apiClient.upload('POST', `leads/leads/upload/preview`, formData)
  }
  getLeadNotes: (leadId: string) => Promise<LeadNoteDto[]> = (leadId) => {
    return this.apiClient.get(`leads/notes/leads/${leadId}`)
  }
  getLeadNote: (noteId: string) => Promise<LeadNoteDto> = (noteId) => {
    return this.apiClient.get(`leads/notes/${noteId}`)
  }
  addLeadNote: (leadNote: CreateLeadNote) => Promise<CreateLeadNote> = (leadNote) => {
    return this.apiClient.post('leads/notes', leadNote)
  }
  updateLeadNote: (leadNote: UpdateLeadNote) => Promise<LeadNoteDto> = (leadNote) => {
    return this.apiClient.put(`leads/notes/${leadNote.id}`, leadNote)
  }
  removeLeadNote: (noteId: string) => Promise<void> = (noteId) => {
    return this.apiClient.delete(`leads/notes/${noteId}`)
  }
  resetLeadActivity: (leadId: string) => Promise<void> = (leadId) => {
    return this.apiClient.put(`leads/leads/${leadId}/reset-activity`, {})
  }
  assignSGL: (data: AssignSGLRequest) => Promise<void> = (data) => {
    return this.apiClient.put('leads/leads/assign-sgl', data)
  }
}
